import instance from '@/services/repository';

const resource = '/kpivalues';

export default {
    GetSingle(payload: IKpiLookupSingle) {
        return instance.post<IKpiValue>(`${resource}/Single`, payload);
    },
    GetLookup(payload: IKpiLookupMultiple) {
        return instance.post<IGraphDto>(`${resource}/Lookup`, payload);
    },
};
